"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "MEDIATYPE", {
  enumerable: true,
  get: function get() {
    return _constants.MEDIATYPE;
  }
});
Object.defineProperty(exports, "REASSIGNED_TYPES", {
  enumerable: true,
  get: function get() {
    return _constants.REASSIGNED_TYPES;
  }
});
exports["default"] = void 0;
var _UnifiedInbox = _interopRequireDefault(require("./components/UnifiedInbox"));
require("./i18n");
require("./styles/css/bundle.css");
var _constants = require("./utils/constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = exports["default"] = _UnifiedInbox["default"];


//////////////////
// WEBPACK FOOTER
// ./~/cw-unified-inbox/dist/index.js
// module id = 595
// module chunks = 0